import Icon from "../../common/Icon";
import mealImage from "../../../assets/images/mealImage.png";
import alert from "../../../assets/images/alert.png";
import CustomAlert from "../../common/CustomAlert";
import { useNavigate } from "react-router-dom";
import Modal from "../../common/Modal";
import { useState } from "react";
import { useToast } from "../../contexts/ToastContext";
import { FaBowlRice } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaClock,
  FaTicketAlt,
  FaReceipt,
  FaInfoCircle,
} from "react-icons/fa";
import { IoCalendarOutline } from "react-icons/io5";
import { FaUser, FaPhoneAlt, FaStar, FaFlag } from "react-icons/fa";
import { FiMail, FiHome, FiMapPin, FiMap, FiUser } from "react-icons/fi";
import { BsBuilding } from "react-icons/bs";
import {
  formatDate,
  getHowManyDaysRemaining,
  getPausedDates,
  getPausedPeriodText,
  getRemainingDays,
  isSubscriptionRenewable,
  includesLongDate,
  is48HoursOrMore,
  isDayPassed,
  isDayPassedOrToday,
  isMealCustomizationPendingInDetails,
  isSnack,
  cleanHTML,
} from "../../utils/commonHelper";
import { FaCirclePause, FaCirclePlay } from "react-icons/fa6";
import axios from "../../../config/axios";
import ContainerLoading from "../../common/loading/ContainerLoading";
import { useGeneral } from "../../contexts/GeneralContext";
import { FaUtensils } from "react-icons/fa";
import { motion } from "framer-motion";
import GeneralButton from "../../common/GeneralButton";
import { IoRefreshCircle } from "react-icons/io5";
import { useCart } from "../../contexts/CartContext";
import FullScreenLoading from "../../common/loading/FullScreenLoading";
const MealDetails = ({ meal, fetchSubscriptions }) => {
  const progressPercent = (meal?.usedMeals / meal?.totalMeals) * 100;
  const navigate = useNavigate();
  const { addToast } = useToast();
  const { extraContent } = useGeneral();
  const { fetchCart } = useCart();
  const [selectedSubId, setSelectedSubId] = useState(null);
  const [selectedRenewSubId, setSelectedRenewSubId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showFood, setShowFood] = useState(false);
  const [activeIndexMap, setActiveIndexMap] = useState({});
  const [showingFoodItem, setShowingFoodItem] = useState(null);
  const today = new Date().toLocaleDateString("en-US", {
    weekday: "long", // e.g., Monday
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const getAllDays = (start, end) => {
    const s = new Date(start);
    const e = new Date(end);

    // Normalize to midnight
    s.setHours(0, 0, 0, 0);
    e.setHours(0, 0, 0, 0);

    const dates = [];

    while (s <= e) {
      const day = s.getDay(); // 0=Sun, 6=Sat

      if (day !== 0 && day !== 6) {
        dates.push(new Date(s));
      }

      s.setDate(s.getDate() + 1);
    }

    return dates;
  };

  const handlePauseClick = (id) => {
    setSelectedSubId(id);
  };
  const width = window.screen.width;
  const handleRenewClick = (id) => setSelectedRenewSubId(id);
  const handleCloseModal = () => setSelectedSubId(null);
  const handleRenewCloseModal = () => setSelectedRenewSubId(null);
  const handleConfirm = async () => {
    if (!selectedSubId) return;

    try {
      setIsLoading(true);

      const { data } = await axios.post("/dashboard/subscriptions/pause-plan", {
        subscriptionId: selectedSubId,
      });

      // ✅ API succeeded
      addToast("Plan paused successfully.", "success");
      setSelectedSubId(null);
      if (fetchSubscriptions) {
        fetchSubscriptions();
      }
    } catch (err) {
      console.error("Pause plan failed:", err);
      addToast(
        err?.response?.data?.message ||
          "Failed to pause plan. Please try again.",
        "error",
      );
    } finally {
      setIsLoading(false);
    }
  };
  const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
  const handleRenew = async () => {
    if (!selectedRenewSubId) return;

    try {
      const mealIds =
        meal?.subscribedMeals?.map((item) => item.meal?._id) || [];

      setIsLoading(true);
      const payload = {
        customerId: loggedInUser?._id,
        previousSubscriptionId: meal?._id,
        isRenewal: "Yes",
        planId: meal?.plan?._id,
        vegOrNonVeg: meal?.vegOrNonVeg,
        mealIds: mealIds,
        childId: meal?.kid?._id,
      };

      const res = await axios.post(
        "/cart/add-renew-meal-subscription-to-cart",
        payload,
      );
      if (res.status === 200 || res.status === 201) {
        setIsLoading(false);
        addToast("Subscription added to cart!", "success");
        localStorage.setItem("mealCartId", res?.data?.cartId);
        await fetchCart();
        navigate("/checkout/meals?renew=true");
      }
    } catch (err) {
      setIsLoading(false);
      console.error("Failed to add subscription to cart:", err);
      addToast(
        "Failed to add subscription to cart. Please try again.",
        "error",
      );
    } finally {
      setIsLoading(false);
    }
  };
  const handleReactivate = async () => {
    if (!selectedSubId) return;

    try {
      setIsLoading(true);

      const { data } = await axios.post(
        "/dashboard/subscriptions/reactivate-plan",
        {
          subscriptionId: selectedSubId,
        },
      );

      // ✅ API succeeded
      addToast("Plan reactivated successfully.", "success");
      setSelectedSubId(null);
      if (fetchSubscriptions) {
        fetchSubscriptions();
      }
    } catch (err) {
      addToast(
        err?.response?.data?.message ||
          "Failed to reactivate plan. Please try again.",
        "error",
      );
    } finally {
      setIsLoading(false);
    }
  };
  const handleAutoRenew = async (id) => {
    try {
      setIsLoading(true);

      const isEnabling = meal?.autoRenew === "0"; // true if enabling, false if disabling

      const { data } = await axios.post("/dashboard/subscriptions/auto-renew", {
        subscriptionId: id,
        action: isEnabling ? "1" : "0",
      });

      // ✅ Show different message based on action
      addToast(
        isEnabling
          ? "Auto-renewal has been activated for your plan."
          : "Auto-renewal has been turned off for your plan.",
        "success",
      );

      setSelectedSubId(null);
      if (fetchSubscriptions) {
        fetchSubscriptions();
      }
    } catch (err) {
      console.error("Failed to update auto-renewal status.", err);

      const isEnabling = meal?.autoRenew === "0";
      addToast(
        err?.response?.data?.message ||
          (isEnabling
            ? "Failed to enable auto-renewal. Please try again."
            : "Failed to disable auto-renewal. Please try again."),
        "error",
      );
    } finally {
      setIsLoading(false);
    }
  };
  const list = meal?.paused?.reactivationDate
    ? getPausedDates(meal?.paused?.pauseDate, meal?.paused?.reactivationDate)
    : [];

  return (
    <>
      <div className="xl:w-full mt-4 lg:mt-6 rounded-[15px] space-y-6 relative">
        {isLoading && <FullScreenLoading />}
        {/* Child Info */}
        <div className="grid lg:grid-cols-2 gap-4 lg:gap-8">
          <div className="bg-[#CFD4CD]/20 flex items-center rounded-[15px] p-3">
            <div className="w-[56px] h-[56px] sm:w-[96px] sm:h-[96px] bg-white border border-[#DEE2DD] rounded-full flex items-center justify-center me-4">
              <Icon
                icon="profile"
                className={`w-[37px] h-[50px] sm:w-[57px] sm:h-[60px] ${
                  meal?.kid?.gender.toLowerCase() === "girl"
                    ? "text-[#FC05B0]/40"
                    : "text-[#0B81FD]/40"
                }`}
              />
            </div>
            <div className="flex flex-[1] flex-col items-start justify-start">
              <p className="text-21pt 2xl:text-24pt leading-light">
                {meal?.kid?.firstName} {meal?.kid?.lastName}
              </p>
              <p className="text-18pt">
                ({meal?.kid?.gender} - {meal?.kid?.age} years old)
              </p>
            </div>
            <div
              title="Click to edit child details"
              className="me-2 cursor-pointer"
              onClick={() =>
                navigate(`/account/profile/edit-child/${meal?.kid?._id}`)
              }
            >
              <Icon
                icon="edit"
                className="w-7 h-7 text-green hover:text-secondary"
              />
            </div>
          </div>

          {/* Plan Info */}
          <div className="bg-[#CFD4CD]/20 flex items-center rounded-[15px] p-3">
            <div className="flex items-center justify-center me-4">
              <img
                src={mealImage}
                className="w-[60px] md:w-[100px] lg:w-[100px] h-auto object-contain"
              />
            </div>
            <div className="flex flex-col items-start justify-start xl:w-full">
              <p className="text-21pt 2xl:text-24pt leading-tight uppercase">
                {meal?.plan?.title} plan - ({meal?.totalMealsInPlan} days meals)
              </p>
              <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between flex-wrap xl:w-full">
                <p className="text-18pt text-quaternary me-2">
                  {meal?.subscribedMeals?.length > 0
                    ? meal.subscribedMeals
                        .map((m) =>
                          isSnack(m?.meal?.title) ? "Snacks" : m?.meal?.title,
                        )
                        .join(" + ")
                    : "None selected"}
                </p>
                <p className="me-2">
                  {" "}
                  <span
                    className={`px-2 py-0.5 font-mono text-[12px] rounded-[5px] text-xs xl:whitespace-nowrap ${
                      meal?.vegOrNonVeg === "Veg"
                        ? "bg-quaternary text-white"
                        : "bg-orange text-secondary text-white"
                    }`}
                  >
                    {meal?.vegOrNonVeg}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 2xl:grid-cols-1 gap-6 items-start">
          <div className="bg-[#DEE2DD]/20 rounded-[15px] p-6 ">
            <h3 className="text-24pt  border-b border-b-gray pb-2 mb-2">
              Subscription Summary{" "}
              {/* {meal?.trialUsed && (
              <span className="bg-tertiary text-white text-10pt px-2 py-1 rounded-full ">
                Trial Used
              </span>
            )} */}
            </h3>
            <div
              className={`grid xl:grid-cols-2 gap-3 xl:gap-6 items-start ${
                meal?.status?.toLowerCase() === "paused" ||
                meal?.status?.toLowerCase() === "cancelled"
                  ? "xl:grid-cols-2"
                  : ""
              }`}
            >
              {meal?.status?.toLowerCase() === "paused" && (
                <div>
                  {(() => {
                    const remainingDays = getRemainingDays(
                      meal?.paused?.pauseDate,
                      extraContent?.mealSubscriptionPauseSettings
                        ?.toleranceDays,
                    );

                    const color = remainingDays < 10 ? "orange" : "green";

                    const bgColor = {
                      red: "bg-red-100 border-red-500 text-red-600",
                      orange: "bg-orange/10 border-orange text-orange",
                      green: "bg-quaternary/20 border-quaternary text-green",
                    }[color];

                    return (
                      <div
                        className={`border-l-4 p-2 rounded-md shadow-sm flex items-center gap-2 mb-2 ${bgColor}`}
                      >
                        <motion.span
                          animate={{
                            rotate: [0, -10, 10, -10, 0],
                            scale: [1, 1.15, 1.05, 1.15, 1],
                          }}
                          transition={{
                            duration: 1.4,
                            repeat: Infinity,
                            ease: "easeInOut",
                          }}
                          className="text-xl"
                        >
                          ⚠️
                        </motion.span>

                        <p className="text-16pt">
                          {remainingDays > 0
                            ? `${remainingDays} days remaining to reactivate.`
                            : "Pause period exceeded; subscription cannot be reactivated."}
                        </p>
                      </div>
                    );
                  })()}

                  {meal?.status?.toLowerCase() === "paused" && (
                    <CustomAlert
                      type="yellow"
                      message={
                        extraContent?.mealSubscriptionPauseSettings
                          ?.tolerancePeriodMessage
                      }
                    />
                  )}

                  {meal?.cancellationReason &&
                    meal?.status?.toLowerCase() === "cancelled" && (
                      <CustomAlert
                        type="error"
                        message={`Cancellation Reason: ${meal?.cancellationReason}`}
                      />
                    )}
                </div>
              )}
              <div className="flex flex-col gap-1">
                {meal?.status?.toLowerCase() === "active" &&
                  meal?.totalMealsInPlan > 5 &&
                  getHowManyDaysRemaining(meal?.subscriptionEndDate) <= 5 && (
                    <div
                      className={`bg-orange/10 border-orange text-orange border-l-4 p-2 rounded-md shadow-sm flex items-center gap-2 mb-2 `}
                    >
                      <motion.span
                        animate={{
                          rotate: [0, -10, 10, -10, 0],
                          scale: [1, 1.15, 1.05, 1.15, 1],
                        }}
                        transition={{
                          duration: 1.4,
                          repeat: Infinity,
                          ease: "easeInOut",
                        }}
                        className="text-xl"
                      >
                        ⚠️
                      </motion.span>

                      <p className="text-16pt">
                        Expiring{" "}
                        {getHowManyDaysRemaining(meal?.subscriptionEndDate) > 0
                          ? `in ${getHowManyDaysRemaining(
                              meal?.subscriptionEndDate,
                            )} days`
                          : "today"}{" "}
                        {meal.isRenewed === "Yes" && (
                          <span className="text-green">
                            (Subscription renewed)
                          </span>
                        )}
                      </p>
                    </div>
                  )}

                {meal?.status?.toLowerCase() === "active" &&
                  meal?.totalMealsInPlan <= 5 &&
                  getHowManyDaysRemaining(meal?.subscriptionEndDate) <= 3 && (
                    <div
                      className={` bg-orange/10 border-orange text-orange
                     border-l-4 p-2 rounded-md shadow-sm flex items-center gap-2 mb-2`}
                    >
                      <motion.span
                        animate={{
                          rotate: [0, -10, 10, -10, 0],
                          scale: [1, 1.15, 1.05, 1.15, 1],
                        }}
                        transition={{
                          duration: 1.4,
                          repeat: Infinity,
                          ease: "easeInOut",
                        }}
                        className="text-xl"
                      >
                        ⚠️
                      </motion.span>

                      <p className="text-16pt">
                        Expiring{" "}
                        {getHowManyDaysRemaining(meal?.subscriptionEndDate) > 0
                          ? `in ${getHowManyDaysRemaining(
                              meal?.subscriptionEndDate,
                            )} days`
                          : "today"}{" "}
                        {meal.isRenewed === "Yes" && (
                          <span className="text-green">
                            (Subscription renewed)
                          </span>
                        )}
                      </p>
                    </div>
                  )}
                {(meal?.status?.toLowerCase() === "paused" ||
                  meal?.status?.toLowerCase() === "cancelled") && (
                  <p className="flex items-center gap-2 text-18pt mb-0 text-18pt">
                    Status:{" "}
                    {meal?.status && (
                      <span
                        className={`px-2 py-0.5 font-mono text-[12px] rounded-[5px] text-xs tracking-wide ${
                          meal?.status === "Active"
                            ? "bg-quaternary text-white"
                            : meal?.status === "Cancelled"
                              ? "bg-red-700 text-white"
                              : "bg-orange text-secondary text-white"
                        }`}
                      >
                        {meal?.status}
                      </span>
                    )}{" "}
                  </p>
                )}
                {meal?.createdAt && (
                  <p className="flex items-center gap-2 text-18pt mt-0">
                    Subscribed On:{" "}
                    <span className="text-orange font-mono">
                      {meal?.createdAt}
                    </span>
                  </p>
                )}
                {meal?.cancellationDate && (
                  <p className="flex items-center gap-2 text-18pt mt-0">
                    Cancellation Date:{" "}
                    <span className="text-orange font-mono">
                      {meal?.cancellationDate}
                    </span>
                  </p>
                )}
                {meal?.paused?.pauseDate && (
                  <p className="flex items-center gap-2 text-18pt mt-0">
                    Paused On:{" "}
                    <span className="text-orange font-mono">
                      {meal?.paused?.pauseDate}
                    </span>
                  </p>
                )}
                {meal?.paused?.reactivationDate && (
                  <p className="flex items-center gap-2 text-18pt mt-0">
                    Reactivated On:{" "}
                    <span className="text-orange font-mono">
                      {meal?.paused?.reactivationDate}
                    </span>
                  </p>
                )}
                {meal?.status === "Paused" && (
                  <p className="flex items-center gap-2 text-18pt mt-0">
                    Subscription Start Date:{" "}
                    <span className="text-orange font-mono">
                      {formatDate(meal.subscriptionStartDate)}
                    </span>
                  </p>
                )}
                {meal?.status === "Active" && (
                  <p className="flex items-center gap-2 text-18pt mt-1">
                    {meal?.subscriptionStartDate && meal?.subscriptionEndDate
                      ? `Meal Delivery: From ${formatDate(
                          meal.subscriptionStartDate,
                        )} - To ${formatDate(meal.subscriptionEndDate)}`
                      : meal?.subscriptionStartDate
                        ? `Starting on ${formatDate(meal.subscriptionStartDate)}`
                        : "No subscription date"}
                  </p>
                )}
                {meal?.depositReturned === "1" && (
                  <p className="flex items-center gap-2 text-18pt mt-2">
                    Deposit Returned:{" "}
                    <span
                      className={` px-2 rounded-[8px] font-bold text-xs font-mono ${
                        meal?.depositReturned === "1"
                          ? "bg-green text-white"
                          : "bg-secondary text-orange"
                      }`}
                    >
                      {meal?.depositReturned === "1" ? "Yes" : "No"}
                    </span>
                  </p>
                )}
                {/* {meal?.depositReturned === "1" &&
                      meal.depositReturnedMessage && (
                        <div className="w-full bg-quaternary/10  border-quaternary px-2 py-1 mt-1 rounded-md shadow-sm flex items-center gap-4 mb-2">
                          <p className="text-quaternary text-[14px] font-mono">
                            Deposit Return Message :{" "}
                            {meal?.depositReturnedMessage}
                          </p>
                        </div>
                      )} */}
                {/* {meal?.status === "Active" &&
                meal?.paused?.pauseDate &&
                meal?.paused?.reactivationDate && (
                  <p className="flex items-center gap-2 text-18pt mt-1">
                    {getPausedPeriodText(meal)}
                  </p>
                )} */}

                {meal?.unreturnedBoxes &&
                  (meal?.status?.toLowerCase() === "paused" ||
                    meal?.status?.toLowerCase() === "cancelled") && (
                    <p className="text-right">
                      Unreturned Boxes:{" "}
                      <strong className="text-orange">
                        {meal?.unreturnedBoxes}
                      </strong>
                    </p>
                  )}
              </div>
              {meal?.status?.toLowerCase() != "paused" &&
                meal?.status?.toLowerCase() != "cancelled" && (
                  <div className="grid  text-sm md:text-18pt gap-2">
                    {meal?.status?.toLowerCase() != "paused" &&
                      meal?.status?.toLowerCase() != "cancelled" && (
                        <p className="flex items-center gap-2 text-18pt mb-0 text-18pt">
                          Status:{" "}
                          {meal?.status && (
                            <span
                              className={`px-2 py-0.5 font-mono text-[12px] rounded-[5px] text-xs tracking-wide ${
                                meal?.status === "Active"
                                  ? "bg-quaternary text-white"
                                  : meal?.status === "Cancelled"
                                    ? "bg-red-700 text-white"
                                    : meal?.status === "Expired"
                                      ? "bg-black text-white "
                                      : "bg-orange text-secondary text-white"
                              }`}
                            >
                              {meal?.status}
                            </span>
                          )}{" "}
                        </p>
                      )}
                    {meal?.status === "Active" && meal?.disclaimerAccepted && (
                      <p className="flex items-center gap-2 text-18pt mt-2">
                        Disclaimer Accepted:{" "}
                        <span
                          className={` px-2 rounded-[8px] font-bold text-xs font-mono ${
                            meal?.disclaimerAccepted === "1"
                              ? "bg-green text-white"
                              : "bg-secondary text-orange"
                          }`}
                        >
                          {meal?.disclaimerAccepted === "1" ? "Yes" : "No"}
                        </span>
                      </p>
                    )}

                    {meal?.unreturnedBoxes && (
                      <p className="text-right">
                        Unreturned Boxes:{" "}
                        <strong className="text-orange">
                          {meal?.unreturnedBoxes}
                        </strong>
                      </p>
                    )}
                  </div>
                )}
              {meal?.status?.toLowerCase() === "cancelled" &&
                meal?.cancellationReason && (
                  <>
                    <div className="bg-orange/15 px-4 py-1 rounded-md shadow-sm mb-3">
                      <h4 className="text-18pt text-orange mb-1">
                        Reason for Cancellation
                      </h4>
                      <p className="text-16pt font-mono">
                        {meal?.cancellationReason || "No reason provided."}
                      </p>
                    </div>
                  </>
                )}
            </div>

            {(meal?.usedMeals || meal?.remainingMeals) && (
              <div className=" rounded-lg space-y-2">
                <div className="flex justify-between text-sm md:text-18pt ">
                  <span>
                    Meals served:{" "}
                    <span className="text-secondary">{meal?.usedMeals}</span>
                  </span>
                  <span>Remaining: {meal?.remainingMeals}</span>
                </div>
                <div className="w-full bg-gray h-2 rounded-full">
                  <div
                    className="bg-quaternary h-2 rounded-full"
                    style={{ width: `${progressPercent}%` }}
                  ></div>
                </div>
              </div>
            )}
            {(meal?.status?.toLowerCase() === "active" ||
              meal?.status?.toLowerCase() === "paused" ||
              (meal?.subscriptionRenewed != "Yes" &&
                (meal?.status?.toLowerCase() === "expired" ||
                  isSubscriptionRenewable(meal?.subscriptionStartDate)))) && (
              <div className="mt-4 md:mt-0 flex flex-col md:flex-row-reverse justify-between items-center xl:items-end w-full ">
                <div className="flex items-center justify-end gap-7">
                  {!isDayPassedOrToday(meal.subscriptionStartDate) &&
                    meal.previousSubscriptionId === null && (
                      <IoCalendarOutline
                        title="Click to change start date"
                        onClick={() =>
                          navigate(
                            `/account/subscriptions/customize/date/${meal._id}`,
                          )
                        }
                        className="text-[28px] text-green hover:text-secondary"
                      />
                    )}
                  {meal?.status?.toLowerCase() === "active" && (
                    <div
                      className=" cursor-pointer"
                      title="Click to customize meal"
                    >
                      <Icon
                        icon={"customize"}
                        className={
                          "w-[30px] 2.5xl:w-[30px] h-auto text-green hover:text-secondary"
                        }
                        onClick={() =>
                          navigate(
                            `/account/subscriptions/customize/${meal?._id}`,
                          )
                        }
                      />
                    </div>
                  )}

                  {/* <div className="me-7 cursor-pointer" title="Click to edit plan">
                  <Icon
                    icon={"edit"}
                    onClick={() =>
                      navigate(`/account/subscriptions/upgrade/${meal._id}`)
                    }
                    className={
                      "w-[25px] lg:w-[30px] 2.5xl:w-[30px] h-auto text-green hover:text-secondary"
                    }
                  />
                </div> */}

                  {meal?.status?.toLowerCase() === "paused" &&
                    isDayPassedOrToday(meal.subscriptionStartDate) &&
                    getRemainingDays(
                      meal?.paused?.pauseDate,
                      extraContent?.mealSubscriptionPauseSettings
                        ?.toleranceDays,
                    ) > 0 && (
                      <div className=" cursor-pointer">
                        <FaCirclePlay
                          title="Click to reactivate plan"
                          onClick={() => handlePauseClick(meal?._id)}
                          className={
                            "text-[30px]  h-auto text-green hover:text-secondary"
                          }
                        />

                        {selectedSubId && (
                          <Modal
                            isOpen={true}
                            onClose={handleCloseModal}
                            title="Reactivate Subscription"
                            onConfirm={handleReactivate}
                          >
                            <div className="font-mono">
                              {/* <p>
                            You’re requesting to reactivate your subscription of{" "}
                            <span>
                              {meal?.plan?.title} plan (
                              {meal?.subscribedMeals?.length > 0
                                ? meal.subscribedMeals
                                    .map((m) => m.meal?.title)
                                    .join(", ")
                                : "None selected"}
                              ) for {meal?.kid?.firstName} {meal?.kid?.lastName}
                            </span>{" "}
                            on {today}.
                          </p> */}
                              <p className="mt-2">
                                {extraContent?.mealReactivateMessages?.line_1}
                              </p>
                              <p className="mt-2 ">
                                {extraContent?.mealReactivateMessages?.line_2}
                              </p>
                            </div>
                          </Modal>
                        )}
                      </div>
                    )}
                  {meal?.status?.toLowerCase() === "active" &&
                    is48HoursOrMore(meal?.subscriptionEndDate) &&
                    isDayPassedOrToday(meal.subscriptionStartDate) &&
                    (meal?.pausedOneTime != "1" ||
                      meal?.pausedOneTime != 1) && (
                      <div className=" cursor-pointer">
                        <FaCirclePause
                          title="Click to pause plan"
                          onClick={() => handlePauseClick(meal?._id)}
                          className={
                            "text-[30px]  h-auto text-green hover:text-secondary"
                          }
                        />

                        {selectedSubId && (
                          <Modal
                            isOpen={true}
                            onClose={handleCloseModal}
                            title="Pause Subscription"
                            onConfirm={handleConfirm}
                          >
                            <div className="font-mono">
                              {/* <p>
                            You’re requesting to pause your subscription of{" "}
                            <span>
                              {meal?.plan?.title} plan (
                              {meal?.subscribedMeals?.length > 0
                                ? meal.subscribedMeals
                                    .map((m) => m.meal?.title)
                                    .join(", ")
                                : "None selected"}
                              ) for {meal?.kid?.firstName} {meal?.kid?.lastName}
                            </span>{" "}
                            on {today}.
                          </p> */}
                              <p className="mt-2">
                                {extraContent?.mealPauseMessages?.line_1}
                              </p>
                              <p className="mt-2 ">
                                {extraContent?.mealPauseMessages?.line_2}
                              </p>
                            </div>
                          </Modal>
                        )}
                      </div>
                    )}
                  {meal?.status?.toLowerCase() === "active" &&
                    is48HoursOrMore(meal?.subscriptionEndDate) &&
                    isDayPassedOrToday(meal.subscriptionStartDate) && (
                      <div
                        className="cursor-pointer"
                        title="Click to cancel plan"
                      >
                        <Icon
                          icon={"mealCancel"}
                          onClick={() =>
                            navigate(
                              `/account/subscriptions/cancel/${meal?._id}`,
                            )
                          }
                          className={
                            "w-[30px] 2.5xl:w-[30px] h-auto text-green hover:text-secondary"
                          }
                        />
                      </div>
                    )}
                  {meal?.isRenewed != "Yes" &&
                    meal?.status?.toLowerCase() != "paused" &&
                    (meal?.status?.toLowerCase() === "expired" ||
                      isSubscriptionRenewable(meal?.subscriptionStartDate)) && (
                      <div className=" cursor-pointer">
                        <IoRefreshCircle
                          title="Click to renew plan"
                          onClick={() => handleRenewClick(meal?._id)}
                          className={
                            "text-[35px]  h-auto text-green hover:text-secondary"
                          }
                        />

                        {selectedRenewSubId && (
                          <Modal
                            isOpen={true}
                            onClose={handleRenewCloseModal}
                            title="Renew Subscription"
                            onConfirm={handleRenew}
                          >
                            <div className="font-mono">
                              <p className="mt-2">
                                Are you sure you want to renew this
                                subscription?
                              </p>
                            </div>
                          </Modal>
                        )}
                      </div>
                    )}
                </div>

                <div
                  className="flex items-end justify-end mt-4 cursor-pointer select-none"
                  // onClick={
                  //   meal?.status?.toLowerCase() === "active"
                  //     ? () => handleAutoRenew(meal._id)
                  //     : () => null
                  // }
                >
                  {/* {meal?.status?.toLowerCase() === "active" && (
                  <>
                    <div className="me-2">
                      <Icon
                        icon={meal?.autoRenew === "1" ? "checked" : "checkbox"}
                        className="w-[20px] h-auto"
                      />
                    </div>
                    <p className="text-green  text-16pt font-mono">
                      Auto renew subscription
                    </p>
                  </>
                )} */}
                </div>
              </div>
            )}
          </div>
          {meal?.address && (
            <div className="bg-[#DEE2DD]/20 rounded-[15px] p-6 space-y-5">
              <h3 className="text-2xl border-b border-gray pb-2 mb-2 flex items-center gap-2">
                Delivery Address
              </h3>

              {/* 👤 USER DETAILS */}
              <div className="grid lg:grid-cols-2 gap-2">
                <div className="space-y-1 text-[18px] text-gray-800">
                  <div className="flex items-center gap-2 mt-1">
                    <FaUser className="text-green text-2xl me-2" />
                    <span>
                      {meal.address.firstName} {meal.address.lastName}
                    </span>
                  </div>

                  <div className="flex items-center gap-2 text-18pt font-mono ml-9">
                    <span>{meal.address.email}</span>
                    <span>|</span>

                    <span>{meal.address.mobile}</span>
                  </div>
                </div>

                {/* 🏠 ADDRESS DETAILS */}
                <div className="space-y-2 text-[18px]">
                  <div className="flex items-start gap-2 me-2">
                    <FiHome className="text-green mt-1 text-2xl shrink-0" />
                    <div className="leading-relaxed ml-2">
                      <p>
                        {meal.address.addressLine1}
                        {meal.address.addressLine2 &&
                          `, ${meal.address.addressLine2}`}{" "}
                        {meal.address.area && `${meal.address.area}, `}
                        {meal.address.city && `${meal.address.city}, `}
                        {meal.address.landmark && `${meal.address.landmark}`}
                      </p>
                      <p>{meal.address.country}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div
            title="Click  to view payment details"
            className=" bg-[#DEE2DD]/20 rounded-[15px] p-6 cursor-pointer"
            onClick={() => navigate(`/account/payments/${meal?.payment?._id}`)}
          >
            <h3 className="text-24pt border-b border-gray pb-2 mb-3 flex items-center gap-2">
              Payment Information
            </h3>

            {/* 💳 Payment Details Grid */}
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-3 text-sm text-gray-800 leading-relaxed items-start ">
              <div className="grid grid-cols-1 gap-3">
                {(meal?.discountAmount > 0 ||
                  meal?.specialDiscountAmount > 0) && (
                  <>
                    <p className="mb-0 text-18pt">
                      <span className="font-mono text-gray-600 text-18pt">
                        Subtotal (Before discount):
                      </span>{" "}
                      {Number(meal?.subTotalBeforeDiscount || 0).toFixed(2)} AED
                    </p>

                    {meal?.discountAmount && (
                      <p className="mb-0 text-18pt">
                        <span className="font-mono text-gray-600 text-18pt">
                          Coupon Discount:
                        </span>{" "}
                        - {Number(meal?.discountAmount).toFixed(2)} AED
                      </p>
                    )}
                    {meal?.specialDiscountAmount && (
                      <p className="mb-0 text-18pt">
                        <span className="font-mono text-gray-600 text-18pt">
                          Special Discount:
                        </span>{" "}
                        - {Number(meal?.specialDiscountAmount).toFixed(2)} AED
                      </p>
                    )}
                  </>
                )}
                <p className="mb-0 text-18pt">
                  <span className="font-mono text-gray-600 text-18pt">
                    Subtotal{" "}
                    {(meal?.discountAmount > 0 ||
                      meal?.specialDiscountAmount > 0) && (
                      <span>(After discount)</span>
                    )}
                    :
                  </span>{" "}
                  {Number(meal?.payment?.subTotal || 0).toFixed(2)} AED
                </p>
                {/* Shipping */}
                {Number(meal?.payment?.shippingCharges || 0) > 0 && (
                  <p className="mb-0 text-18pt">
                    <span className="font-mono text-gray-600 text-18pt">
                      Shipping:
                    </span>{" "}
                    {Number(meal?.payment?.shippingCharges || 0) > 0
                      ? `${Number(meal?.payment?.shippingCharges).toFixed(
                          2,
                        )} AED`
                      : "Free"}
                  </p>
                )}
                <p className="mb-0 text-18pt">
                  <span className="font-mono text-gray-600 text-18pt">
                    VAT:
                  </span>{" "}
                  {Number(meal?.payment?.vatAmount || 0).toFixed(2)} AED
                </p>

                {meal?.payment?.depositAmount?.$numberDecimal > 0 && (
                  <div className="grid grid-cols-1 gap-2">
                    <p className="mb-0 text-18pt">
                      <span className="font-mono text-gray-600 text-18pt">
                        Deposit (refundable):
                      </span>{" "}
                      {Number(
                        meal?.payment?.depositAmount?.$numberDecimal || 0,
                      ) > 0
                        ? `${Number(
                            meal?.payment?.depositAmount?.$numberDecimal,
                          ).toFixed(2)} AED`
                        : "Free"}
                    </p>
                    {meal?.payment?.depositAmount?.$numberDecimal > 0 &&
                      (meal?.payment?.depositAmountFromPreviousSubscription ===
                        "1" ||
                        meal?.payment?.depositAmountFromPreviousSubscription ===
                          1) && (
                        <div className="w-fit bg-orange/10  border-orange px-2 py-1 mt-0 rounded-md shadow-sm flex items-center gap-4">
                          <p className="text-orange text-[13px] font-mono">
                            The deposit amount has been carried forward from the
                            previous subscription upon renewal.
                          </p>
                        </div>
                      )}
                  </div>
                )}

                {/* VAT */}

                {/* Total */}
                <p
                  className={
                    meal?.payment?.depositAmount?.$numberDecimal > 0 &&
                    (meal?.payment?.depositAmountFromPreviousSubscription ===
                      "1" ||
                      meal?.payment?.depositAmountFromPreviousSubscription ===
                        1)
                      ? "border-t border-gray pt-2 mt-2 mb-0 text-18pt"
                      : "mb-0 text-18pt "
                  }
                >
                  <span className="font-mono">Total Amount:</span>{" "}
                  <span className=" text-18pt text-green mt-2 ">
                    {Number(meal?.payment?.totalAmount || 0).toFixed(2)} AED
                  </span>
                </p>
              </div>
              <div className="grid grid-cols-1 gap-3">
                <p className="mb-0 text-18pt">
                  <span className="font-mono text-gray-600 text-18pt">
                    Method:
                  </span>{" "}
                  Credit/Debit Card
                </p>
                {/* {meal?.payment?.stripePaymentId && (
                <p className="mb-0 text-18pt">
                  <span className="font-mono text-gray-600 text-18pt">
                    Transaction ID:
                  </span>{" "}
                  {meal?.payment?.stripePaymentId}
                </p>
              )} */}
                {meal?.payment?.date && (
                  <p className="mb-0 text-18pt">
                    <span className="font-mono text-gray-600 text-18pt">
                      Date:
                    </span>{" "}
                    {formatDate(meal?.payment?.date)}
                  </p>
                )}
                {meal?.payment?.invoiceUrl && (
                  <p className="mb-0 text-18pt">
                    <span className="font-mono text-gray-600 text-18pt">
                      Invoice:
                    </span>{" "}
                    <a
                      href={meal?.payment?.invoiceUrl}
                      className="text-primary hover:underline flex items-center gap-1"
                      download
                    >
                      <FaReceipt /> Download
                    </a>
                  </p>
                )}
                {meal?.appliedCouponId && meal?.appliedCoupon && (
                  <div className="flex items-center gap-3 mt-3 border border-dashed border-orange-400 text-orange-700 bg-orange-50 rounded-[8px] px-5 py-2 w-fit shadow-sm">
                    <FaTicketAlt className="text-orange-500 text-lg" />
                    <div className="flex flex-col text-18pt">
                      <span className="">
                        Coupon Applied: {meal?.appliedCoupon?.couponCode}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* 🎟️ Coupon Section */}
          </div>

          {meal?.upcomingDeliveries && (
            <div className="bg-[#DEE2DD]/20 rounded-[15px] p-6 space-y-4">
              <h3 className="text-24pt  border-b border-b-gray pb-2 mb-2">
                Upcoming Delivery
              </h3>
              {meal?.upcomingDeliveries?.map((delivery, idx) => (
                <div key={idx} className="space-y-2">
                  <p className=" text-green mb-3">{delivery.date}</p>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                    {delivery.meals.map((m, mid) => (
                      <div key={mid} className="flex flex-col items-center">
                        <img
                          src={m.thumbnail}
                          alt={m.name}
                          className="w-16 h-16 object-cover rounded-md"
                        />
                        <p className="text-sm mt-2  text-center">{m.name}</p>
                        <p className="text-xs text-orange capitalize ">
                          {m.type}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {isMealCustomizationPendingInDetails(meal) &&
          meal.status === "Active" &&
          (extraContent?.mealCustomizationMessages?.line_1 ||
            extraContent?.mealCustomizationMessages?.line_2) && (
            <div className="relative order-1 2.5xl:order-2 mt-4">
              <div className="md:sticky  w-full rounded-[15px] bg-secondary overflow-y-auto">
                <div className="ps-8 pe-8 py-6 relative">
                  <div className="2xl:min-w-[208px]">
                    <p className="text-white text-18pt mb-4">Please note:</p>
                    {extraContent?.mealCustomizationMessages?.line_1 && (
                      <p className="text-white text-18pt font-mono mb-4">
                        {extraContent?.mealCustomizationMessages?.line_1}
                      </p>
                    )}
                    {extraContent?.mealCustomizationMessages?.line_2 && (
                      <p className="text-white text-18pt font-mono">
                        {extraContent?.mealCustomizationMessages?.line_2}
                      </p>
                    )}
                  </div>
                  <img
                    src={alert}
                    className="absolute w-[30px] md:w-[49px] lg:w-[30px] 2.5xl:w-[49px] right-5 top-5 md:top-6"
                  />
                </div>
              </div>
            </div>
          )}
        {/* {meal?.selectedMeals?.length > 0 && meal.status === "Active" && (
          <div className="bg-[#DEE2DD]/20 rounded-[15px] p-6 space-y-4">
            <div className="flex flex-col md:flex-row justify-between md:items-center mb-2">
              <h3 className="text-24pt ">
                Selected Meals{" "}
                <span className="text-18pt font-mono">
                  (
                  {meal?.subscriptionStartDate && meal?.subscriptionEndDate
                    ? `from ${formatDate(
                        meal.subscriptionStartDate,
                      )} - to ${formatDate(meal.subscriptionEndDate)}`
                    : meal?.subscriptionStartDate
                      ? `Starting on ${formatDate(meal.subscriptionStartDate)}`
                      : "No subscription date"}
                  )
                </span>{" "}
              </h3>
              <button
                onClick={() =>
                  navigate(`/account/subscriptions/customize/${meal?._id}`)
                }
                className="bg-orange text-white px-4 py-1 rounded-lg hover:bg-green-600 transition"
              >
                Customize Meals
              </button>
            </div>
            <div
              style={{ maxWidth: `${width - 60}px` }}
              className={`overflow-x-auto md:w-full`}
            >
              <table className="table-auto rounded-md w-full">
                <thead className="">
                  <tr>
                    <th className="px-4 py-2 border border-gray font-sans font-normal">
                      Date
                    </th>
                    {meal?.subscribedMeals.map((m) => (
                      <th
                        key={m.meal._id}
                        className="xl:px-4 xl:py-2 border border-gray font-sans font-normal"
                      >
                        {isSnack(m?.meal?.title) ? "Snacks" : m?.meal?.title}
                      </th>
                    ))}
                    <th className="xl:px-4 xl:py-2 border border-gray font-sans font-normal">
                      Status
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {Object.entries(
                    meal?.selectedMeals?.reduce((acc, curr) => {
                      const date = curr.date;
                      if (!acc[date]) acc[date] = [];
                      acc[date].push(curr);
                      return acc;
                    }, {}) || {},
                  )
                    .sort(
                      ([dateA], [dateB]) =>
                        new Date(dateA).getTime() - new Date(dateB).getTime(),
                    )
                    .map(([date, mealsForDay], idx) => {
                      const today = new Date().setHours(0, 0, 0, 0);
                      const dayDate = new Date(date).setHours(0, 0, 0, 0);

                      let statusClass = "text-gray-500";
                      if (dayDate < today) statusClass = "text-green-600";

                      return (
                        <tr key={idx} className="text-center text-18pt">
                          <td className="px-4 py-2 border border-gray font-mono">
                            {date}
                          </td>

                          {meal?.subscribedMeals.map((sub) => {
                            const selected = mealsForDay.find(
                              (m) => m.meal?._id === sub.meal?._id,
                            );
                            return (
                              <td
                                key={sub.meal._id}
                                onClick={() => {
                                  setShowFood(true);
                                  setShowingFoodItem(selected);
                                }}
                                title={
                                  selected ? "Click to view meal details" : ""
                                }
                                className={`px-4 py-2  border border-gray font-mono font-normal ${
                                  selected
                                    ? "cursor-pointer hover:text-orange hover:underline"
                                    : ""
                                }`}
                              >
                                {selected ? selected.food?.title : "-"}
                              </td>
                            );
                          })}

                          <td
                            className={`px-4 py-2 border border-gray font-mono  gap-2 ${statusClass}`}
                          >
                            <div className="flex flex-col md:flex-row items-center justify-center gap-2">
                              {(() => {
                                if (includesLongDate(list, date)) {
                                  return (
                                    <>
                                      <FaInfoCircle className="text-[#808080] text-lg" />
                                      <span className="text-[#808080]">
                                        Paused
                                      </span>
                                    </>
                                  );
                                } else if (isDayPassedOrToday(date)) {
                                  return (
                                    <>
                                      <FaCheckCircle className="text-quaternary text-lg" />
                                      <span>Delivered</span>
                                    </>
                                  );
                                } else if (!is48HoursOrMore(date)) {
                                  return (
                                    <>
                                      <FaClock className="text-orange text-lg" />
                                      <span>Confirmed</span>
                                    </>
                                  );
                                } else {
                                  return (
                                    <>
                                      <FaUtensils className="text-tertiary text-lg" />
                                      <span>Meal Selected</span>
                                    </>
                                  );
                                }
                              })()}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        )} */}
        {meal.status === "Active" && (
          <div className="bg-[#DEE2DD]/20 rounded-[15px] p-6 space-y-4">
            <div className="flex flex-col md:flex-row justify-between md:items-center mb-2">
              <h3 className="text-24pt">
                Selected Meals{" "}
                <span className="text-18pt font-mono">
                  (
                  {meal?.subscriptionStartDate && meal?.subscriptionEndDate
                    ? `from ${formatDate(meal.subscriptionStartDate)} - to ${formatDate(meal.subscriptionEndDate)}`
                    : meal?.subscriptionStartDate
                      ? `Starting on ${formatDate(meal.subscriptionStartDate)}`
                      : "No subscription date"}
                  )
                </span>
              </h3>
              <button
                onClick={() =>
                  navigate(`/account/subscriptions/customize/${meal?._id}`)
                }
                className="bg-orange text-white px-4 py-1 rounded-lg hover:bg-green-600 transition"
              >
                Customize Meals
              </button>
            </div>

            <div
              style={{ maxWidth: `${width - 60}px` }}
              className="overflow-x-auto md:w-full"
            >
              <table className="table-auto rounded-md w-full">
                <thead>
                  <tr>
                    <th className="px-4 py-2 border border-gray font-sans font-normal">
                      Date
                    </th>
                    {meal?.subscribedMeals.map((m) => (
                      <th
                        key={m.meal._id}
                        className="xl:px-4 xl:py-2 border border-gray font-sans font-normal"
                      >
                        {isSnack(m?.meal?.title) ? "Snacks" : m?.meal?.title}
                      </th>
                    ))}
                    <th className="xl:px-4 xl:py-2 border border-gray font-sans font-normal">
                      Status
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {getAllDays(
                    meal.subscriptionStartDate,
                    meal.subscriptionEndDate,
                  ).map((d, idx) => {
                    const dateStr = formatDate(d);
                    const today = new Date().setHours(0, 0, 0, 0);
                    const isPaused = includesLongDate(list, dateStr);
                    const isPast = d < today;

                    // Timezone-safe meal matching
                    const mealsForDay =
                      meal?.selectedMeals?.filter((m) => {
                        const mealDate = new Date(m.date);
                        mealDate.setHours(0, 0, 0, 0);
                        const current = new Date(d);
                        current.setHours(0, 0, 0, 0);
                        return mealDate.getTime() === current.getTime();
                      }) || [];

                    let statusClass = "text-gray-500";
                    if (isPast) statusClass = "text-green-600";

                    return (
                      <tr
                        key={idx}
                        className={`text-center text-16pt
                  ${isPast ? "opacity-80 bg-[#eee] " : ""}
                  ${isPaused ? "bg-[#ccc] text-gray-700" : ""}
                `}
                      >
                        <td
                          className="px-4 py-2 border border-gray font-mono"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {dateStr}
                        </td>

                        {isPaused ? (
                          // 👇 +1 covers meal columns + Status column in one line
                          <td
                            colSpan={meal.subscribedMeals.length + 1}
                            className="px-4 py-2 border border-gray font-mono font-bold text-center"
                          >
                            <div className="flex items-center justify-center gap-2 text-gray-700">
                              <span
                                style={{
                                  fontWeight: "normal",
                                  fontSize: "16px",
                                }}
                              >
                                Paused by You
                              </span>
                            </div>
                          </td>
                        ) : (
                          <>
                            {meal?.subscribedMeals.map((sub) => {
                              const selected = mealsForDay.find(
                                (m) => m.meal?._id === sub.meal?._id,
                              );
                              return (
                                <td
                                  key={sub.meal._id}
                                  onClick={() => {
                                    if (selected) {
                                      setShowFood(true);
                                      setShowingFoodItem(selected);
                                    }
                                  }}
                                  title={
                                    selected ? "Click to view meal details" : ""
                                  }
                                  className={`px-4 py-2 border border-gray font-mono font-normal ${
                                    selected
                                      ? "cursor-pointer hover:text-orange hover:underline"
                                      : ""
                                  }`}
                                >
                                  {selected ? selected.food?.title : "-"}
                                </td>
                              );
                            })}

                            <td
                              className={`px-4 py-2 border border-gray font-mono ${statusClass}`}
                            >
                              <div className="flex flex-col md:flex-row items-center justify-center gap-2">
                                {isDayPassedOrToday(dateStr) ? (
                                  <>
                                    <FaCheckCircle className="text-quaternary text-lg" />
                                    <span>Delivered</span>
                                  </>
                                ) : !is48HoursOrMore(dateStr) ? (
                                  <>
                                    <FaClock className="text-orange text-lg" />
                                    <span>Confirmed</span>
                                  </>
                                ) : (
                                  <>
                                    <FaUtensils className="text-tertiary text-lg" />
                                    <span>Meal Selected</span>
                                  </>
                                )}
                              </div>
                            </td>
                          </>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      <Modal
        isOpen={showFood}
        onClose={() => setShowFood(false)}
        closeOnOutClick={true}
        title={""}
        showConfirm={false}
        showCancel={false}
        customClass="max-w-[70%] max-h-[80%] overflow-scroll"
      >
        {showingFoodItem?.meal?.title?.toLowerCase() != "lunch" && (
          <>
            <p className="text-34pt text-left leading-none mb-4">
              {showingFoodItem?.food?.title}
            </p>

            <div className="group relative bg-white rounded-xl flex flex-col md:flex-row items-start gap-4 text-left">
              {/* Left info */}
              <div className="flex-1 w-full">
                <div className="flex items-center flex-wrap gap-3 mb-3">
                  {showingFoodItem?.food?.vegOrNonVeg && (
                    <span
                      className={`flex items-center gap-1 text-14pt px-3 py-1 rounded-full ${
                        showingFoodItem?.food?.vegOrNonVeg === "Veg"
                          ? "bg-green/10 text-green"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      <span
                        className={`w-2.5 h-2.5 me-1 rounded-full ${
                          showingFoodItem?.food?.vegOrNonVeg === "Veg"
                            ? "bg-green/80"
                            : "bg-red-600"
                        }`}
                      ></span>
                      {showingFoodItem?.food?.vegOrNonVeg}
                    </span>
                  )}

                  {showingFoodItem?.food?.hotOrCold && (
                    <span
                      className={`text-14pt px-3 py-1 rounded-full ${
                        showingFoodItem?.food?.hotOrCold === "Hot"
                          ? "bg-orange/20 text-orange"
                          : "bg-blue-100 text-blue-500"
                      }`}
                    >
                      {showingFoodItem?.food?.hotOrCold}
                    </span>
                  )}

                  {showingFoodItem?.food?.nutritionalInfo && (
                    <div className="flex flex-wrap gap-2">
                      {showingFoodItem?.food?.nutritionalInfo
                        .split(",")
                        .map((nutri, idx) => (
                          <span
                            key={idx}
                            className="border border-quaternary text-quaternary text-14pt px-2 py-1 rounded-full"
                          >
                            {nutri.trim()}
                          </span>
                        ))}
                    </div>
                  )}
                </div>

                {/* Allergens */}
                {showingFoodItem?.food?.allergens?.filter(
                  (a) => a.trim() !== "",
                ).length > 0 && (
                  <div className="w-fit bg-orange/10 border-l-4 border-orange p-2 mt-4 rounded-md shadow-sm flex items-center gap-2">
                    <motion.span
                      animate={{
                        rotate: [0, -10, 10, -10, 0],
                        scale: [1, 1.15, 1.05, 1.15, 1],
                      }}
                      transition={{
                        duration: 1.4,
                        repeat: Infinity,
                        ease: "easeInOut",
                      }}
                      className="text-orange text-xl"
                    >
                      ⚠️
                    </motion.span>

                    <p className="text-orange text-18pt font-sans">
                      Allergens:{" "}
                      {showingFoodItem?.food?.allergens
                        .filter((a) => a.trim() !== "")
                        .join(", ")}
                    </p>
                  </div>
                )}

                {/* Description */}
                <div className="text-sm text-gray-700 mt-4 leading-relaxed ">
                  {showingFoodItem?.food?.ingredients && (
                    <p className="text-24pt font-mono flex items-center flex-wrap gap-0 ">
                      <FaBowlRice size={24} className="text-quaternary me-2" />
                      <span className="font-sans  leading-relaxed">
                        Ingredients:
                      </span>
                      <span className="leading-[35px] text-[22px] capitalize">
                        {showingFoodItem?.food?.ingredients}
                      </span>
                    </p>
                  )}
                  {showingFoodItem?.food?.description && (
                    <p
                      className="subtitle text-24pt abouthtml1 font-mono "
                      dangerouslySetInnerHTML={{
                        __html: cleanHTML(showingFoodItem?.food?.description),
                      }}
                    />
                  )}
                </div>
              </div>

              {/* ------- Image Swiper ------- */}
              <div
                // title="Click to enlarge image"
                className="flex-shrink-0 w-[200px] h-[200px] cursor-pointer"
                // onClick={() => handleShowModal(mealItem)}
              >
                <Swiper
                  modules={[Pagination, Autoplay]}
                  pagination={{ clickable: true }}
                  autoHeight={true}
                  className="w-full h-full review small"
                  onSlideChange={(s) => {
                    setActiveIndexMap((prev) => ({
                      ...prev,
                      [showingFoodItem?.food?._id]: s.realIndex,
                    }));
                  }}
                >
                  {/* Main Image */}
                  {showingFoodItem?.food?.image && (
                    <SwiperSlide
                      key="main"
                      className="cursor-pointer flex items-center justify-center bg-white aspect-[1/1] relative pb-10 hover:shadow-lg transition-shadow"
                    >
                      <img
                        src={`${process.env.REACT_APP_BACKEND_URL}public/${showingFoodItem?.food?.image}`}
                        alt={showingFoodItem?.food?.title}
                        onError={(e) => {
                          e.currentTarget.src = require("../../../assets/images/link.png");
                          e.currentTarget.classList.add("object-contain");
                        }}
                        className="w-full h-[200px] object-contain bg-gray rounded-lg"
                      />
                    </SwiperSlide>
                  )}

                  {/* Extra Images */}
                  {Array.isArray(showingFoodItem?.food?.pictures) &&
                    showingFoodItem?.food?.pictures
                      .slice(0, 2)
                      .map((img, i) => (
                        <SwiperSlide
                          key={i}
                          className="cursor-pointer flex items-center justify-center bg-white aspect-[1/1] relative pb-10"
                        >
                          <img
                            src={`${process.env.REACT_APP_BACKEND_URL}public/${img.image}`}
                            alt={showingFoodItem?.food?.title}
                            onError={(e) => {
                              e.currentTarget.src = require("../../../assets/images/link.png");
                              e.currentTarget.classList.add("object-contain");
                            }}
                            className="w-full h-[200px] object-contain bg-gray rounded-lg"
                          />
                        </SwiperSlide>
                      ))}
                </Swiper>
              </div>
            </div>
          </>
        )}
        {showingFoodItem?.meal?.title?.toLowerCase() === "lunch" && (
          <>
            <div
              key={showingFoodItem?.food?._id}
              className="group relative   bg-white rounded-xl  gap-4 text-left "
            >
              {/* Left info */}

              <div className="flex flex-col md:flex-row  lg:items-start justify-between gap-6">
                <div className="flex-1 w-full">
                  <p className="text-32pt mb-4">
                    {showingFoodItem?.food?.title}
                  </p>
                  <div className="flex items-center flex-wrap gap-3 mb-3">
                    {showingFoodItem?.food?.vegOrNonVeg && (
                      <span
                        className={`flex items-center gap-1 text-14pt px-3 py-1 rounded-full ${
                          showingFoodItem?.food?.vegOrNonVeg === "Veg"
                            ? "bg-green/10 text-green"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        <span
                          className={`w-2.5 h-2.5 me-1 rounded-full ${
                            showingFoodItem?.food?.vegOrNonVeg === "Veg"
                              ? "bg-green/80"
                              : "bg-red-600"
                          }`}
                        ></span>
                        {showingFoodItem?.food?.vegOrNonVeg}
                      </span>
                    )}

                    {showingFoodItem?.food?.hotOrCold && (
                      <span
                        className={`text-14pt px-3 py-1 rounded-full ${
                          showingFoodItem?.food?.hotOrCold === "Hot"
                            ? "bg-orange/20 text-orange"
                            : "bg-blue-100 text-blue-500"
                        }`}
                      >
                        {showingFoodItem?.food?.hotOrCold}
                      </span>
                    )}

                    {showingFoodItem?.food?.nutritionalInfo && (
                      <div className="flex flex-wrap gap-2">
                        {showingFoodItem?.food?.nutritionalInfo
                          .split(",")
                          .map((nutri, idx) => (
                            <span
                              key={idx}
                              className="border border-quaternary text-quaternary text-14pt px-2 py-1 rounded-full"
                            >
                              {nutri.trim()}
                            </span>
                          ))}
                      </div>
                    )}
                  </div>

                  {/* Allergens */}
                  {showingFoodItem?.food?.allergens?.filter(
                    (a) => a.trim() !== "",
                  ).length > 0 && (
                    <div className="w-fit bg-orange/10 border-l-4 border-orange p-2 mt-4 rounded-md shadow-sm flex items-center gap-2">
                      <motion.span
                        animate={{
                          rotate: [0, -10, 10, -10, 0],
                          scale: [1, 1.15, 1.05, 1.15, 1],
                        }}
                        transition={{
                          duration: 1.4,
                          repeat: Infinity,
                          ease: "easeInOut",
                        }}
                        className="text-orange text-xl"
                      >
                        ⚠️
                      </motion.span>

                      <p className="text-orange text-18pt font-sans">
                        Allergens:{" "}
                        {showingFoodItem?.food?.allergens
                          .filter((a) => a.trim() !== "")
                          .join(", ")}
                      </p>
                    </div>
                  )}

                  {/* Description */}
                </div>

                {/* ------- Image Swiper ------- */}
                <div
                  // title="Click to enlarge image"
                  className="flex-shrink-0 w-[200px] h-[200px] cursor-pointer"
                  // onClick={() => handleShowModal(showingFoodItem)}
                >
                  <Swiper
                    modules={[Pagination, Autoplay]}
                    pagination={{ clickable: true }}
                    autoHeight={true}
                    className="w-full h-full review small"
                    onSlideChange={(s) => {
                      setActiveIndexMap((prev) => ({
                        ...prev,
                        [showingFoodItem?.food?._id]: s.realIndex,
                      }));
                    }}
                  >
                    {/* Main Image */}
                    {showingFoodItem?.food?.image && (
                      <SwiperSlide
                        key="main"
                        className={`cursor-pointer flex items-center justify-center bg-white aspect-[1/1] relative  hover:shadow-lg transition-shadow ${
                          showingFoodItem?.food?.pictures?.length > 0
                            ? "pb-10"
                            : ""
                        }`}
                      >
                        <img
                          src={`${process.env.REACT_APP_BACKEND_URL}public/${showingFoodItem?.food?.image}`}
                          alt={showingFoodItem?.food?.title}
                          onError={(e) => {
                            e.currentTarget.src = require("../../../assets/images/link.png");
                            e.currentTarget.classList.add("object-contain");
                          }}
                          className="w-full h-[200px] object-contain bg-gray rounded-lg"
                        />
                      </SwiperSlide>
                    )}

                    {/* Extra Images */}
                    {showingFoodItem?.food?.pictures &&
                      Array.isArray(showingFoodItem?.food?.pictures) &&
                      showingFoodItem?.food?.pictures
                        ?.slice(0, 2)
                        .map((img, i) => (
                          <SwiperSlide
                            key={i}
                            className={`cursor-pointer flex items-center justify-center bg-white aspect-[1/1] relative ${
                              showingFoodItem?.food?.pictures.length > 0
                                ? "pb-10"
                                : ""
                            }`}
                          >
                            <img
                              src={`${process.env.REACT_APP_BACKEND_URL}public/${img.image}`}
                              alt={img.image}
                              onError={(e) => {
                                e.currentTarget.src = require("../../../assets/images/link.png");
                                e.currentTarget.classList.add("object-contain");
                              }}
                              className="w-full h-[200px] object-contain bg-gray rounded-lg"
                            />
                          </SwiperSlide>
                        ))}
                  </Swiper>
                </div>
              </div>

              <div
                className={`text-sm text-gray-700 leading-relaxed ${
                  showingFoodItem?.food?.pictures?.length > 0
                    ? "mt-10 "
                    : "mt-4  "
                }`}
              >
                {showingFoodItem?.food?.description && (
                  <p
                    className={`subtitle text-24pt  font-mono ${"abouthtml1"}`}
                    dangerouslySetInnerHTML={{
                      __html: cleanHTML(showingFoodItem?.food?.description),
                    }}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default MealDetails;
